import React from "react";
import { TabEventProps } from "models/propTypes/tabPropTypes";

const TabEvents: React.FC<TabEventProps> = (props) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const onTabChange = (event: React.SyntheticEvent, value: number) => {
    setCurrentIndex(value);
  };

  const resetTabIndex = () => {
    setCurrentIndex(0);
  };

  return <>{props.render(currentIndex, onTabChange, resetTabIndex)}</>;
};

export default TabEvents;
